//we are importing stylesheets related files here, because putting non-js files as webpack entries generate js as well, see: https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/518 
import '../_scss/global.scss';
import '../_scss/index.scss';
import '../_scss/plugins.scss';

import './index';
import { UI } from './ui';
import lozad from 'lozad';

// lazy loading using lozad.js
// https://github.com/ApoorvSaxena/lozad.js

const loadAssets = lozad('.lazy'); // lazy loads elements with default selector as '.lozad'
loadAssets.observe();


UI.init();
UI.nav.bind('nav--top', 'menu-item-has-children');
UI.resizeHeaderOnScroll.bind();

window.addEventListener('resize', () => { UI.init() } );


